import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ModalConfirmation from "../../../common/components/Modal/ModalConfirmation";
import { useAppDispatch, useAppSelector } from "../../../common/state/hooks";
import {
  closeConfirmationModal,
  openConfirmationModal,
} from "../../../common/state/slice/modal/modalSlice";
import { useDemoDataCleanup } from "../hooks/useDemoDataCleanup";
import { closeDemoCleanupPrompt, selectDemoCleanupPromptOpen } from "../state/onboardingSlice";

export const DEMO_CLEANUP_PROMPT_MODAL_ID = "onboarding-demo-cleanup-prompt";

export const DemoCleanupPrompt = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const promptOpen = useAppSelector(selectDemoCleanupPromptOpen);
  const { runCleanup } = useDemoDataCleanup({ sessionsMode: "summary" });

  useEffect(() => {
    if (promptOpen) {
      dispatch(openConfirmationModal(DEMO_CLEANUP_PROMPT_MODAL_ID));
    }
  }, [promptOpen, dispatch]);

  if (!promptOpen) {
    return null;
  }

  const handleSubmit = (): void => {
    dispatch(closeConfirmationModal(DEMO_CLEANUP_PROMPT_MODAL_ID));
    dispatch(closeDemoCleanupPrompt());
    runCleanup();
  };

  const handleCancel = (): void => {
    dispatch(closeDemoCleanupPrompt());
  };

  return (
    <ModalConfirmation
      id={DEMO_CLEANUP_PROMPT_MODAL_ID}
      title={t("onboarding.demoData.promptTitle")}
      text={t("onboarding.demoData.promptText")}
      submitButtonText={t("onboarding.demoData.deleteButton")}
      cancelButtonText={t("onboarding.demoData.promptKeep")}
      danger
      focusCancel
      onClickSubmit={handleSubmit}
      onClickCancel={handleCancel}
    />
  );
};

export default DemoCleanupPrompt;
